<template>
  <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading"
    >Loading ...</a-card
  >
  <a-row :gutter="8" v-else>
    <loading v-if="anggaran.loadingtree" />
    <a-col :xs="{ span: 24 }">
      <div>
        <a-tabs :activeKey="activeTabUsage" @change="callbackTab">
          <a-tab-pane tab="Petty Cash Details" key="pettycash" >
            <a-form :form="form">
              <a-row :gutter="16">
                <a-col :span="24">
                  <a-form-item label="Description">
                    <a-input
                      v-decorator="['deskripsi', { rules: [{ required: true }] }]"
                    ></a-input>
                  </a-form-item>

                  <a-form-item label="Jenis Anggaran">
                    <a-select
                      showSearch
                      :not-found-content="null"
                      option-filter-prop="children"
                      v-decorator="[
                        'jenis_anggaran',
                        {
                          rules: [{ required: true }],
                        },
                      ]"
                      @change="handleJenisAnggaran"
                    >
                      <a-select-option
                        v-for="item in getJenisAnggaran"
                        :key="item.value"
                      >
                        {{ item.text }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="Cost Center">
                    <!-- <a-row :gutter="16">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">-->
                    <a-select
                      :disabled="costCenter.length == 0"
                      showSearch
                      v-decorator="[
                        'cost_center',
                        {
                          rules: [{ required: true }],
                        },
                      ]"
                      @change="handleCost"
                    >
                      <a-select-option v-for="item in costCenter" :key="item.value">
                        {{ item.text }} ({{
                          item.nama_pekerjaan ? item.nama_pekerjaan : "-"
                        }})
                      </a-select-option>
                    </a-select>
                    <!-- </a-col>    
                    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                      <a-button type="primary" 
                        :disabled="!modalanggaran.enabled"
                        @click="showChoiceModal"
                        :loading="modalanggaran.loadingButton"
                        size="small"
                        >
                        Select Financing Code
                      </a-button>
                    </a-col>    
                    </a-row>-->
                  </a-form-item>
                  <a-form-item label="Peruntukan">
                    <a-select
                      :disabled="peruntukan.length == 0"
                      showSearch
                      v-decorator="[
                        'peruntukan',
                        {
                          rules: [{ required: true }],
                        },
                      ]"
                      @change="handlePeruntukan"
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option v-for="item in peruntukan" :key="item.value">
                        {{ item.text }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Kode Anggaran">
                    <a-tree-select
                      v-decorator="['kode_anggaran', { rules: [{ required: true }] }]"
                      show-search
                      style="width: 100%"
                      @select="handlechoiceCost"
                      :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                      :tree-data="anggaran.tree"
                      treeNodeFilterProp="children"
                      :filterTreeNode="filterTreeNode"
                      placeholder="Please select"
                      allow-clear
                      :treeExpandedKeys="treeExpandedKeys"
                      :disabled="
                        anggaran.loadingtree ||
                        anggaran.tree == undefined ||
                        anggaran.tree.length == 0
                      "
                    >
                      <span slot="title" slot-scope="item">
                        <table style="width: 100%">
                          <tr>
                            <td>
                              <span
                                >{{ item.texttitle }} - {{ item.kode_anggaran }}</span
                              >
                            </td>
                            <td>
                              <span style="float: right">{{
                                formatRupiah(parseFloat(item.rekap))
                              }}</span>
                            </td>
                          </tr>
                        </table>
                      </span>
                    </a-tree-select>
                  </a-form-item>

                  <a-form-item label="Prospect No" v-if="selectedCostCenter=='07'">
                    <a-select
                      showSearch
                      :not-found-content="null"
                      option-filter-prop="children"
                      v-decorator="[
                        'prospek',
                        {
                          rules: [{ required: false }],
                        },
                      ]"
                    >
                      <a-select-option
                        v-for="item in listProspect"
                        :key="item.id_prospek"
                      >
                        {{ item.no_prospek }} - {{ item.description }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="Petty Cash Expenditures">
                    <a-input-number
                      class="m-width-full m-text-align-right"
                      :formatter="
                        (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      "
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                      v-decorator="[
                        'pengeluaran_kas_kecil',
                        { rules: [{ required: true }, { validator: checkPrice }] },
                      ]"
                    />
                  </a-form-item>
                  <a-form-item label="Expense Date">
                    <a-date-picker
                      placeholder="Select Date"
                      :format="getDefaultDateFormat"
                      v-decorator="[
                        'tanggal_pengeluaran',
                        { rules: [{ required: true }] },
                      ]"
                    />
                  </a-form-item>
                  <a-form-item label="End User">
                    <a-select
                      showSearch
                      v-decorator="[
                        'end_user',
                        {
                          rules: [{ required: true }],
                        },
                      ]"
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option v-for="item in allKaryawan" :key="item.tlc">
                        {{ item.nama + " (" + item.tlc + ")" }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Upload Transaction Document">
                    <a-upload
                      :showUploadList="true"
                      :fileList="doctransfiles"
                      :beforeUpload="beforedoctransUpload"
                      :remove="handledoctransRemove"
                      v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
                    >
                      <a-button>
                        <a-icon type="upload" />&nbsp;Select File
                      </a-button>
                    </a-upload>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <div>
              <a-divider class="margin-bottom-small">or</a-divider>
              <div>
                <h4>Upload Excel File</h4>
                <p>
                  If You Don't Have a File Upload Template Please Click
                  <a-button class="padding-remove" type="link" @click="handleDownload"
                    >Download Template</a-button
                  >
                </p>
                <a-upload
                  accept=".xls, .xlsx"
                  :showUploadList="true"
                  :fileList="push"
                  :beforeUpload="beforeUpload"
                  :remove="handleRemove"
                  v-decorator="['upload', { valuePropName: 'push' }]"
                >
                  <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
                </a-upload>
                <a-divider v-if="getScreen"></a-divider>
              </div>
            </div>
            <a-button
              v-if="getScreen"
              type="primary"
              block
              @click="handleNew"
              :loading="newLoading"
              >Add</a-button>
          </a-tab-pane>
          <a-tab-pane tab="Bailout Details" key="bailout">
            <a-form :form="formPC">
              <a-row :gutter="16">
                <a-col :span="24">
                  <a-form-item label="Bailout Transaction">
                    <a-select
                      showSearch
                      v-decorator="[
                        'id_bailout',
                        {
                          rules: [{ required: true }],
                        },
                      ]"
                      optionFilterProp="children"
                      :filterOption="filterOption"
                      :loading="bailoutSelectLoading"
                    >
                      <a-select-option v-for="item in listBailout" :key="item.id_bailout">
                        <div class="m-display-flex space-between">
                          <span>{{ item.no_sppd + " | " + item.tlc_create }}</span>
                          <span>{{ formatCurrency('IDR',item.bailout_value) }}</span>
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-tab-pane>
        </a-tabs> 
      </div>
    </a-col>
    <a-col :xs="{ span: 24 }" v-if="getScreen">
      <a-collapse class="margin-top">
        <a-collapse-panel key="1">
          <h4 slot="header" class="margin-remove">View Details</h4>
          <a-list
            itemLayout="vertical"
            :dataSource="dataList"
            :pagination="pagination"
          >
            <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <a-row slot="title" type="flex" justify="space-between">
                  <a href="#">{{ item.deskripsi }}</a>
                </a-row>
                <ul slot="description" class="m-list-wrapper">
                  <li class="margin-remove">
                    {{
                      moment(item.tanggal_pemakaian).format(
                        getDefaultDateFormat
                      )
                    }}
                  </li>
                  <li class="margin-remove">
                    {{ item.alokasi }} | {{ item.proyek }}
                  </li>

                  <li>
                    <h3 class="margin-remove">
                      {{ formatRupiah(item.kredit) }}
                    </h3>
                  </li>
                </ul>
              </a-list-item-meta>
              <a-button-group v-if="getScreen && item.kredit !== ''">
                <a-button type="primary" @click="handleEdit(item)">
                  <a-icon type="edit" />&nbsp;Edit
                </a-button>
                <a-button type="danger" @click="handleRemoveDetail(item)">
                  <a-icon type="close" />&nbsp;Remove
                </a-button>
              </a-button-group>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
      <div class="m-price-total">
        <!--  <h3 class="margin-remove m-text-align right" >Total : {{formatCurrency(mata_uang,totalPrice)}}</h3>
          <h3 class="margin-remove m-text-align right" >Tax ({{tax+'%'}}) : {{formatCurrency(mata_uang,nilaiPajak)}}</h3>
        <h3 class="margin-remove m-text-align right" v-if="check_shipping">Shipping Cost  : {{formatCurrency(mata_uang,shipping)}}</h3>-->
        <a-statistic
          title="Grand Total"
          :value="formatRupiah(this.kredit)"
          class="m-text-align right"
        />
      </div>
      <!--<div class="m-price-total" v-if="pageLoading === false">-->
      <!--<div class="m-display-flex space-between align-middle">-->
      <!--<h4>Total Kredit</h4>-->
      <!--<h3>{{formatRupiah(initialList.kredit)}}</h3>-->
      <!--</div>-->
      <!--</div>-->
      <a-checkbox :disabled="dataList.length < 1" @change="handleCheckData"
        >Is Data Completed?</a-checkbox
      >
    </a-col>

    <Modal
      :informasi="informasi"
      :data="modal.data"
      :modalEdit="modal.modalEdit"
      :confirmLoading="modal.confirmLoading"
      :dataList="dataList"
    />

    <a-modal
      v-model="modalanggaran.visible"
      v-if="modalanggaran.visible"
      title="Choice Financing Code"
      :footer="null"
      :width="700"
    >
      <a-tree-select
        v-model="modalanggaran.value"
        show-search
        style="width: 100%"
        @change="handlechoiceCost"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :tree-data="modalanggaran.tree"
        treeNodeFilterProp="children"
        :filterTreeNode="filterTreeNode"
        placeholder="Please select"
        allow-clear
        tree-default-expand-all
      >
        <span slot="title" slot-scope="item">
          <table style="width: 100%">
            <tr>
              <td>
                <span>{{ item.texttitle }} - {{ item.kode_anggaran }}</span>
              </td>
              <td>
                <span style="float: right">{{
                  formatRupiah(parseFloat(item.rekap))
                }}</span>
              </td>
            </tr>
          </table>
        </span>
      </a-tree-select>
    </a-modal>

    <a-modal
      title="Confirmation"
      :visible="confirm"
      @ok="handleconfirmOk"
      :confirmLoading="confirmLoading"
      @cancel="handleconfirmCancel"
      okText="OK"
      cancelText="Cancel"
      :maskClosable="false"
    >
      <p>
        The data that has been added will be overwritten with your new file? Are
        you sure?
      </p>
    </a-modal>
  </a-row>
</template>

<script>
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Modal from "../Modal.vue";
import Loading from "@/components/preloader/Loading.vue";

export default {
  name: "pemakaian",
  components: {
    Modal,
    Loading,
  },
  mixins: [CurrencyFormat],
  props: {
    data: {},
    informasi: {},
    mode: {},
    url: "",
    id_kas: "",
    dataList: {},
    dataListBailout: {},
    debit: 0,
    kredit: 0,
    mata_uang: "",
    type: "",
  },
  data() {
    return {
      push: [],
      confirm: false,
      confirmLoading: false,
      newLoading: false,
      pageLoading: true,
      bailoutSelectLoading: false,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      initialEdit: {},
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: "",
          id: "",
          type: "",
          alokasi: "",
          proyek: "",
        },
      },
      kategori: "",
      peruntukan: [],
      subPeruntukan: [],
      anggaran: {
        peruntukan_id: "",
        anggaran_id: "",
        id_kas: "",
        modalvalue: undefined,
        path: "",
        limit: 0,
        tree: [],
        treeModal: [],
        searchValue: "",
        loadingtree: false,
      },
      modalanggaran: {
        visible: false,
        enabled: false,
        loadingButton: false,
        value: undefined,
        tree: {},
        searchValue: "",
      },
      costCenter: [],
      treeExpandedKeys: [],
      doctransfiles: [],
      listBailout: [],
      listBailoutoriginal: [],
      activeTabUsage: "pettycash",
      selectedCostCenter: null,
      listProspect: [],
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAlokasi",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
      "getJenisAnggaran",
      "getAllKaryawan",
    ]),
    initialList() {
      if (this.dataList.length > 0) {
        let kredit = 0;
        let data = this.dataList;
        if (this.dataList.length > 1 || this.dataList !== undefined) {
          data.forEach((item) => {
            kredit = parseInt(kredit) + parseInt(item.kredit);
          });
        }

        return { kredit: kredit };
      } else {
        return { kredit: 0 };
      }
    },
    allKaryawan(){
      let output = this.getAllKaryawan;

      output = _.filter(output, item => this.informasi.type == 'bod' ? item.posisi == 'Direktur' : item.posisi !== 'Direktur')

      return output;
    }
  },
  created() {
    this.$store.dispatch("FETCH_COST_CENTER");
    this.fetchPemakaian();
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formPC = this.$form.createForm(this);
    this.formEdit = this.$form.createForm(this);
  },
  methods: {
    moment,
    recountingAnggaran(arr) {
      arr = arr.filter((obj) => obj.path !== "");
      if (arr.length > 0) {
        //restore nominal ke origin
        arr.forEach((elm) => {
          if (elm.path) {
            let ObjVal = elm.path.split(";");
            let path1 = "";
            let path2 = "";
            let path3 = "";
            let trigerpath = true;
            let tempTree = this.anggaran.tree;
            ObjVal.forEach((element) => {
              if (path1 == "") {
                path1 += "tempTree[" + element + "]";
                path3 = path1;
              } else {
                path3 = path1 + ".children";
                path1 += ".children[" + element + "]";
              }
              if (trigerpath) {
                if (!eval(path3)) {
                  trigerpath = false;
                  return;
                } else {
                  if (!eval(path1)) {
                    trigerpath = false;
                    return;
                  }
                }
              }
            });

            if (trigerpath) {
              path2 = eval(path1 + ".origin_rekap");
              eval(path1 + ".rekap=" + path2);
              //eval(path1+".disabled=false")
            }
          }
        });
        //menghitung nominal dengan acuan nominal origin
        arr.forEach((elem) => {
          if (elem.path) {
            let ObjVal = elem.path.split(";");
            let path = "";
            let tpath = "";
            let trigerpath = true;
            let tempTree = this.anggaran.tree;
            ObjVal.forEach((element) => {
              if (path == "") {
                path += "tempTree[" + element + "]";
                tpath = path;
              } else {
                tpath = path + ".children";
                path += ".children[" + element + "]";
              }
              if (trigerpath) {
                if (!eval(tpath)) {
                  trigerpath = false;
                  return;
                } else {
                  if (!eval(path)) {
                    trigerpath = false;
                    return;
                  }
                }
              }
            });
            if (trigerpath) {
              let kd_anggrn = eval(path + ".kode_anggaran");
              if (kd_anggrn == elem.kode_anggaran) {
                let oldVal = eval(path + ".rekap");
                let num = oldVal - parseFloat(elem.kredit);
                let exe = path + ".rekap=" + num;
                eval(exe);
                if (num <= 0) {
                  eval(path + ".disabled=true");
                } else {
                  eval(path + ".disabled=false");
                }
              }
            }
            this.anggaran.tree = tempTree;
          }
        });
      }
    },
    getTreeAnggaran() {
      this.anggaran.loadingtree = true;
      let dataParams =
        this.mode == "Edit" && this.type == "revised"
          ? {
              anggaran_id: this.anggaran.anggaran_id,
              tlc: this.getAuth.username,
              peruntukan_id: this.anggaran.peruntukan_id,
              id_kas: this.id_kas,
            }
          : {
              anggaran_id: this.anggaran.anggaran_id,
              tlc: this.getAuth.username,
              peruntukan_id: this.anggaran.peruntukan_id,
            };
      if (dataParams.peruntukan_id) {
        axios({
          method: "get",
          url: this.$serviceUrl + "kas_kecil/tree_anggaran",
          params: dataParams,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.anggaran.tree = response.data.tree;
            this.anggaran.treeModal = [
              ...this.anggaran.treeModal,
              response.data.tree[0],
            ];
            let arr = this.dataList.filter((item) => item.kredit !== "");
            this.recountingAnggaran(arr);

            this.treeExpandedKeys = this.getParent(response.data.tree);

            if(this.selectedCostCenter=='07'){
              this.getProspectList();
            }else{
              this.anggaran.loadingtree = false;
            }
          })
          .catch((err) => {
            this.anggaran.loadingtree = false;
            console.log(err);
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
          });
      }
    },
    // filterTreeNode(input, option) {
    //   return (
    //     option.data.props.texttitle==undefined || (option.data.props.texttitle ? option.data.props.texttitle : "").toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
    //     (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "").toLowerCase().indexOf(input.toLowerCase()) >= 0
    //   );
    // },
    handleCodeAnggarn(e) {
      let forms = this.form.getFieldsValue();
      this.modalanggaran.value =
        forms.peruntukan + ";" + forms.sub_peruntukan + ";" + e;
    },
    filterTreeNode(input, option) {
      //console.log(input, option)
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechoiceCost(value, record) {
      
      // if (val){
      //   let kod = val.split(";")
      //   this.$nextTick(function () {
      //     this.handlePeruntukan(kod[0]);
      //     this.form.setFieldsValue({
      //         peruntukan: kod[0],
      //     });
      //     this.handleSubPeruntukan(kod[1]);
      //     this.form.setFieldsValue({
      //         sub_peruntukan: kod[1],
      //         kode_anggaran: kod[2]
      //     });
      //   });
      // }else{
      //   this.$nextTick(function () {
      //     this.form.setFieldsValue({
      //         peruntukan: undefined,
      //         sub_peruntukan: undefined,
      //         kode_anggaran: undefined
      //     });
      //   });
      // }
      this.anggaran.limit = record.dataRef.rekap;
      this.anggaran.path = record.dataRef.path;
      this.modalanggaran.visible = false;
    },
    showChoiceModal() {
      this.modalanggaran.visible = true;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleCost(e) {
      // this.modalanggaran.enabled = false;
      // this.modalanggaran.loadingButton = true;
      // axios({
      //   method: "get",
      //   url: this.$serviceUrl + "anggaran/tree_anggaran",
      //   params: {
      //     anggaran_id: e,
      //     tlc: this.getAuth.username,
      //   },
      //   auth: {
      //     username: this.getAuth.username,
      //     password: this.getAuth.password,
      //   },
      //   headers: {
      //     "X-API-KEY": this.getAuth.apikey,
      //   },
      // })
      //   .then((response) => {
      //     //console.log(response);
      //     this.modalanggaran.enabled = true;
      //     this.modalanggaran.loadingButton = false;
      //     this.modalanggaran.tree = response.data.tree;
      //   })
      //   .catch((err) => {
      //     let responses = Object.assign({}, err.response);
      //   });

      this.form.resetFields(["peruntukan", "sub_peruntukan", "kode_anggaran"]);
      this.subPeruntukan = [];
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
      const peruntukan = this.getPeruntukan.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.peruntukan = peruntukan;

      this.anggaran.anggaran_id = e;
    },
    handlePeruntukan(e) {
      this.form.resetFields(["sub_peruntukan", "kode_anggaran"]);
      this.anggaran.peruntukan_id = e;
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
      const filter = this.getSubPeruntukan.filter(
        (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.subPeruntukan = filter;
      this.getTreeAnggaran();
    },
    handleSubPeruntukan(e) {
      this.form.resetFields(["kode_anggaran"]);
      const filter = this.getAnggaran.filter(
        (obj) => obj.anggaran_dtl_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      //this.anggaran = filter;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
    },
    done() {
      this.pageLoading = false;
    },
    fetchPemakaian() {
      this.pageLoading = true;
      Event.$emit("fetchPemakaian", true);
    },
    handleRemove() {
      this.push = [];
    },
    handleRemoveDetail(e) {
      if (this.mode == "Edit" && this.dataList.length == 2) {
        this.displayMessageValue(
          "error-other",
          "can not delete this data, because this transaction has at least 1 data!"
        );
      } else {
        Event.$emit("removeDetail", e);
      }
    },
    handleNew() {
      if(this.activeTabUsage=="bailout"){
        this.formPC.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }
          let valSelected = _.filter(this.listBailout, item => item.id_bailout==values.id_bailout)
          if(this.validateBailoutMinus(Number(valSelected[0].bailout_value))) {
            return;
          }else{
            this.handleNewProcessBailout(values)
          }
        })
      }else{
        if (this.push.length > 0){
          this.handleNewProcess();
        }else{
          this.form.validateFields((err, values) => {
            if (err) {
              this.newLoading = false;
              this.pageLoading = false;
              this.displayMessage("form-warning");
              return;
            }
            //antisipasi error bigint postgresql
            // if (this.dataList && this.dataList.length>0 && this.debit>0){
            //   let nom = this.kredit+parseFloat(values.pengeluaran_kas_kecil)
            //   if (this.debit<nom){
            //     this.displayMessageValue("error-other","The value max Petty Cash is "+this.formatRupiah(this.debit))
            //     return
            //   }else{
            //     this.confirmMessageValue("confirm-add-detil", true);
            //   }
            // }else{
            //if(this.validateBailoutMinus(values.pengeluaran_kas_kecil)) return;
            
            if(moment(values.tanggal_pengeluaran).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
              this.displayMessageValue("error-other", "Usage date can't exceed today!");
              return;
            }

            this.confirmMessageValue("confirm-add-detil", true);
            //}
          });
        }
      }
    },
    handleNewProcess() {
      let addData = new FormData();
      this.newLoading = true;
      Event.$emit("handleLoading", true);

      addData.append("tlc", this.getAuth.username);
      addData.append("id_kas", this.id_kas);
      addData.append(
        "tanggal_pelaporan",
        this.informasi.tanggal_pelaporan.format(this.getStandartFormatDate)
      );
      addData.append("approval_pic", this.informasi.pic);
      addData.append("approval_bod", this.informasi.bod);
      addData.append("type_kas", this.informasi.type == 'nonbod'? 'N' : 'B');

      if (this.push.length > 0 && this.dataList.length > 1) {
        this.confirm = true;
      } else if (this.push.length > 0) {
        this.push.forEach((file) => {
          addData.append("file_upload", file);
        });

        this.newLoading = true;
        this.pageLoading = true;

        this.postUpload(addData);
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.newLoading = false;
            this.pageLoading = false;
            Event.$emit("handleLoading", false);
            this.displayMessage("form-warning");
            return;
          }
          addData.append(
            "tanggal_pengeluaran",
            values.tanggal_pengeluaran.format(this.getStandartFormatDate)
          );
          addData.append("pengeluaran_kas_kecil", values.pengeluaran_kas_kecil);
          addData.append("deskripsi", values.deskripsi ? values.deskripsi : "");
          let kd = values.kode_anggaran.split(";");
          addData.append("kode_anggaran", kd[kd.length - 1]);
          addData.append("sub_peruntukan", kd[kd.length - 2]);
          addData.append("peruntukan", values.peruntukan);
          addData.append("cost_center", values.cost_center);
          addData.append("anggaran_dtl_val_id", kd[kd.length - 1]);
          addData.append("jenis_anggaran", values.jenis_anggaran);
          addData.append("path", this.anggaran.path);
          addData.append("end_user", values.end_user);
          if (this.doctransfiles && this.doctransfiles.length > 0) {
            this.doctransfiles.forEach((file) => {
              addData.append("file_upload", file);
            });
          }
          if(values.prospek){
            addData.append("prospek", values.prospek);
          }

          this.newLoading = true;

          axios({
            method: "post",
            url: this.url,
            processData: false,
            data: addData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success-add");
              this.fetchPemakaian();
              this.newLoading = false;
              this.pageLoading = false;
              this.form.resetFields();
              if (this.mode === "Create") {
                Event.$emit("disableInformasi", true);
              }

              this.costCenter = [];
              this.peruntukan = [];
              this.subPeruntukan = [];
              this.anggaran.tree = [];
              this.anggaran.treeModal = [];
              this.modalanggaran.value = null;
              this.doctransfiles = [];
            })
            .catch((err) => {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
              console.log("error : " + err);
              Event.$emit("handleLoading", false);
            });
        });
      }
    },
    handleNewProcessBailout(values) {
      this.newLoading = true;
      Event.$emit("handleLoading", true);

      let addData = new FormData();
      addData.append("id_bailout", values.id_bailout);
      addData.append("id_kas", this.id_kas);
      addData.append("approval_pic", this.getAuth.username);
      addData.append("tanggal_pelaporan", moment().format(this.getStandartFormatDate));
      addData.append("approval_pic", this.getAuth.username);
      addData.append("type_kas", this.informasi.type == 'nonbod'? 'N' : 'B');

      axios({
        method: "post",
        url: this.$serviceUrl + "kas_kecil/bailout",
        processData: false,
        data: addData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        this.displayMessage("success-add");
        // this.fetchPemakaian();
        this.newLoading = false;
        this.pageLoading = false;
        Event.$emit("handleLoading", false);
        // Event.$emit("fetchPemakaian", true);
        this.fetchPemakaian();
        Event.$emit("getComboBailouts", true);
        this.formPC.resetFields();
        // if (this.mode === "Create") {
        //   Event.$emit("disableInformasi", true);
        // }

        // this.costCenter = [];
        // this.peruntukan = [];
        // this.subPeruntukan = [];
        // this.anggaran.tree = [];
        // this.anggaran.treeModal = [];
        // this.modalanggaran.value = null;
        // this.doctransfiles = [];
      })
      .catch((err) => {
        let responses = Object.assign({}, err.response.data);
        this.displayMessageValue("error-other", responses.message);
        console.log("error : " + err);
        Event.$emit("handleLoading", false);
      });
    },
    postUpload(data) {
      let url =
        this.type === "revised"
          ? "kas_kecil/revisi_upload_detil_pemakaian"
          : "kas_kecil/upload_detil_pemakaian";
      axios({
        method: "post",
        url: this.$serviceUrl + url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (this.mode === "Create") {
            this.push = [];
            this.displayMessage("success-add");
            this.fetchPemakaian();
            this.newLoading = false;
            this.pageLoading = false;
            this.confirm = false;
            this.confirmLoading = false;
            Event.$emit("disableInformasi", true);
          } else {
            this.push = [];
            this.displayMessage("success-edit");
            this.fetchPemakaian();
            this.newLoading = false;
            this.pageLoading = false;
            this.confirm = false;
            this.confirmLoading = false;
            Event.$emit("disableInformasi", true);
          }
          Event.$emit("handleLoading", false);
        })
        .catch((err) => {
          console.log(err);
          let responses = Object.assign({}, err.response);
          if (responses.data) {
            this.displayMessageValue("error-other", responses.data.message);
          } else {
            this.displayMessageValue("error", responses);
          }
          Event.$emit("handleLoading", false);
          this.newLoading = false;
          this.pageLoading = false;
          this.confirm = false;
          this.confirmLoading = false;
        });
    },
    handleCheckData(e) {
      Event.$emit("draftStatus", e.target.checked);
    },
    handleEdit(item) {
      this.modal.data = {
        path: item.path,
        tanggal_pemakaian: item.tanggal_pemakaian,
        deskripsi: item.deskripsi,
        kredit: item.kredit,
        id: item.id,
        type: this.type,
        proyek: item.proyek,
        alokasi: item.alokasi,
        jns_anggaran_id: item.jns_anggaran_id,
        anggaran_code:
          item.kode_anggaran_id == "null;null;null"
            ? undefined
            : item.kode_anggaran_id,
        end_user:
          item.end_user !== null
            ? item.end_user.substring(0, 3).toUpperCase()
            : null,
      };
      this.modal.modalEdit = true;
      this.modal.type = this.type;
    },
    handleDownload() {
      axios({
        method: "get",
        url: this.$serviceUrl + "/main/download_template_kk",
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          window.open(this.$serviceUrl + response.data.url, "_blank");
        })
        .catch((err) => {
          this.displayMessage("error-emptyDocTemplate");
        });
    },
    handleCancel(e) {
      this.confirm = false;
      this.modal.modalEdit = false;
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    handleProyek(value) {
      let filter = this.project.filter(
        (obj) =>
          obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
      );

      this.kategori = filter[0].kategori;
      this.form.setFieldsValue({
        alokasi: "",
      });
    },
    handleJenisAnggaran(e) {
      this.selectedCostCenter = e
      this.listProspect = []
      this.form.resetFields([
        "cost_center",
        "peruntukan",
        "sub_peruntukan",
        "kode_anggaran",
        "id_prospect"
      ]);
      const filter = this.getCostCenter.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.modalanggaran.enabled = false;
      this.costCenter = filter;
      this.subPeruntukan = [];
      this.peruntukan = [];
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
    },
    resetFormPemakaian() {
      this.form.resetFields();
      this.costCenter = [];
      this.peruntukan = [];
      this.anggaran.tree = [];
    },
    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },
    handleconfirmOk() {
      Event.$emit("handleLoading", true);
      this.ModalText = "The modal will be closed after two seconds";
      this.confirmLoading = true;

      let addData = new FormData();

      addData.append("tlc", this.getAuth.username);
      addData.append("id_kas", this.id_kas);
      // addData.append("no_sppd", this.informasi.no_sppd);
      addData.append(
        "tanggal_pelaporan",
        this.informasi.tanggal_pelaporan.format(this.getStandartFormatDate)
      );
      addData.append("approval_pic", this.informasi.pic);
      addData.append("approval_bod", this.informasi.bod);
      addData.append("type_kas", this.informasi.type == 'nonbod'? 'N' : 'B');

      if (this.push.length > 0) {
        this.push.forEach((file) => {
          addData.append("file_upload", file);
        });
      }

      this.postUpload(addData);
    },
    handleconfirmCancel() {
      this.confirm = false;
      //this.modal.modalEdit = false;
      Event.$emit("handleLoading", false);
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
    async getListBailouts(type){
      let dataParams = null 
      if(this.id_kas){
        dataParams = {
          id_kas: this.id_kas
        }
      }
      this.bailoutSelectLoading = true
      await axios({
          method: "get",
          url: this.$serviceUrl + "kas_kecil/bailout",
          params: dataParams,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(async (response) => {
            this.listBailout = response.data.data
            
            if(type=='onmounted'){
              this.listBailoutoriginal = response.data.data
              Event.$emit("listBailoutToParent", this.listBailoutoriginal);
            }
            await this.comboBailoutFiltering()
            this.bailoutSelectLoading = false
          })
          .catch(() => {
          });
    },
    comboBailoutFiltering(){
      let result = this.listBailoutoriginal
      this.dataListBailout.forEach(element => {
          result = _.filter(result, item => item.id_bailout!=element.id_bailout)
      });
      this.listBailout = result
    },
    callbackTab(val){
      this.activeTabUsage = val;
    },
    validateBailoutMinus(value){
      let res = ((this.debit?this.debit:value)-((this.kredit?this.kredit:0)+value)) >= 0 ? false : true
      if(res){
        this.displayMessageValue("error-other", "Calculate Grand total can't be minus!");
      }
      return res
    },
    async getProspectList(){
      await axios({
        method: "get",
        url: this.$serviceUrl + "prospek/pilih_prospek",
        params: {
          anggaran_id: this.anggaran.anggaran_id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then(async (response) => {
        this.listProspect = response.data.data ? response.data.data : [];
        this.anggaran.loadingtree = false;
      })
      .catch(() => {
      });
    }
  },
  mounted() {
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("confirmMessageAddDetil", this.handleNewProcess);
    Event.$on("resetdtlpemakaian", this.resetFormPemakaian);
    Event.$on("getComboBailouts", this.getListBailouts);
    Event.$on("comboBailoutFiltering", this.comboBailoutFiltering);
    this.getListBailouts('onmounted')
  },
  beforeDestroy() {
    Event.$off("modalCancel", this.handleCancel);
    Event.$off("confirmMessageAddDetil", this.handleNewProcess);
    Event.$off("resetdtlpemakaian", this.resetFormPemakaian);
    Event.$off("getComboBailouts", this.getListBailouts);
    Event.$off("comboBailoutFiltering", this.comboBailoutFiltering);
  },
  // watch: {
  //   dataListBailout(){
  //     if(this.dataListBailout){
  //       console.log("terwatch")
  //       this.comboBailoutFiltering();
  //     }
  //   }
  // }
};
</script>

<style lang="less">
.ant-select-selection-selected-value {
  width: 100%;
}
</style>